import { Icon } from '../types/icons';

export const hangerIcons: Icon[] = [
  {
    key: 'https://cdn.easysize.me/icons/hanger.svg',
    url: 'https://cdn.easysize.me/icons/hanger.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Hanger%20Outline%201.svg',
    url: 'https://cdn.easysize.me/icons/Hanger%20Outline%201.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Hanger%20Outline%202.svg',
    url: 'https://cdn.easysize.me/icons/Hanger%20Outline%202.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Hanger%20Outline%203.svg',
    url: 'https://cdn.easysize.me/icons/Hanger%20Outline%203.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Hanger%20Outline%204.svg',
    url: 'https://cdn.easysize.me/icons/Hanger%20Outline%204.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Hanger%20Outline%20Solid%201.svg',
    url: 'https://cdn.easysize.me/icons/Hanger%20Outline%20Solid%201.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Hanger%20Outline%20Solid%202.svg',
    url: 'https://cdn.easysize.me/icons/Hanger%20Outline%20Solid%202.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Hanger+solid+1.svg',
    url: 'https://cdn.easysize.me/icons/Hanger+solid+1.svg',
  },
  {
    key: 'https://cdn.easysize.me/icons/Hanger%20Solid%202.svg',
    url: 'https://cdn.easysize.me/icons/Hanger%20Solid%202.svg',
  },
];
